module.exports = __webpack_public_path__ + "img/myaccount.9954d478.png";